export const getTwelveHourTimeFromString = (time: string) => {
  const [hours, minutes] = time.split(':');

  const date = new Date();
  date.setHours(Number(hours), Number(minutes));

  return Number(minutes) > 0
    ? date.toLocaleTimeString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(' ', '')
    : date.toLocaleTimeString('en-AU', { hour: 'numeric', hour12: true }).replace(' ', '');
};
